import 'semantic-ui-css/semantic.min.css';
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import store from "./store";
import { Provider } from "react-redux";
import registerServiceWorker from "./registerServiceWorker";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

/**
 * Makes the app installable — nothing else.
 *
 * The worker caches nothing, so a deploy still takes effect on the next
 * refresh exactly as it always has. See public/sw.js.
 */
registerServiceWorker();
